@if (resource(); as selectedResource) {
<section class="resource-page">
  <div class="page-header">
    <h2 class="page-title">{{ selectedResource.title }}</h2>
  </div>

  <div class="toolbar">
    <lib-search-input
      [(ngModel)]="searchTerm"
      [placeholder]="'Ara...'"
      (searchChange)="onSearch($event)"
      (clear)="onSearch('')"
    />
    <lib-button variant="primary" (buttonClick)="onSearch(searchTerm)">
      <span class="btn-content">
        <svg lucideSearch [size]="15" [strokeWidth]="2" aria-hidden="true"></svg>
        Ara
      </span>
    </lib-button>
    <lib-button variant="outline" [loading]="isLoading()" (buttonClick)="reload()">
      <span class="btn-content">
        <svg lucideRefreshCw [size]="15" [strokeWidth]="2" aria-hidden="true"></svg>
        Yenile
      </span>
    </lib-button>
  </div>

  @if (errorMessage()) {
  <div class="alert alert--error">{{ errorMessage() }}</div>
  }

  <div class="table-card">
    @if (isLoading()) {
    <div class="state-message">Veriler yükleniyor...</div>
    } @else if (rows().length === 0) {
    <div class="state-message">Bu alanda gösterilecek kayıt bulunamadı.</div>
    } @else {
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            @for (column of visibleColumns(); track column) {
            <th>{{ columnLabel(column) }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of rows(); track rowIndex($index)) {
          <tr>
            @for (column of visibleColumns(); track column) {
            <td>{{ formatValue(cellValue(row, column)) }}</td>
            }
          </tr>
          }
        </tbody>
      </table>
    </div>

    <lib-pagination
      [currentPage]="currentPage()"
      [totalPages]="totalPages()"
      [pageSize]="pageSize()"
      [totalItems]="totalItems()"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)"
    />
    }
  </div>
</section>
} @else {
<section class="resource-page">
  <div class="alert alert--error">
    İstenen portal yönetim alanı bulunamadı.
  </div>
</section>
}
